import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UserManager } from '@gls-group/gls-user-manager';
import { AuthenticationService } from '../authentication.service';
import { ErrorHandlerService } from '../error-handler.service';
import {
  EventOptionsBuilder,
  GoogleAnalyticsService
} from '../google-analytics-service';

@Component({
  selector: 'app-attempt-logout',
  template: ` <ngx-gls-spinner></ngx-gls-spinner> `,
})
export class AttemptLogoutComponent implements OnInit {
  private userManager: UserManager;
  constructor(
    private auth: AuthenticationService,
    private http: HttpClient,
    private googleAnalyticsService: GoogleAnalyticsService,
    private error: ErrorHandlerService
  ) {
    this.userManager = auth.userManager;
  }

  ngOnInit(): void {
    this.googleAnalyticsService.sendPageView(
      'Authentication: Logout',
      '/authenticate/logout'
    );
    const eventBuilder = new EventOptionsBuilder();
    eventBuilder
      .setCategory('SSO Authentication Logout')
      .setPage('/authenticate/logout')
      .setNonInteraction(true);

    this.http.get(this.auth.productLogoutURI).subscribe(
      () => {
        if (this.auth.postLogoutRedirectURL) {
          this.userManager
            .signOut({
              post_logout_redirect_uri: this.auth.postLogoutRedirectURL,
            })
            .catch((error) => {
              eventBuilder
                .setAction('API ERROR')
                .setLabel(
                  `POST_LOGOUT_URI:${
                    this.auth.postLogoutRedirectURL
                  }:ERROR_MESSAGE:${JSON.stringify(error)}`
                );
              this.googleAnalyticsService.sendEvent(eventBuilder.getResult());
              this.error.navigateToErrorPage();
            });
        } else {
          this.userManager.signOut().catch((error) => {
            eventBuilder
              .setAction('API ERROR')
              .setLabel(
                `DEFAULT LOGOUT::ERROR_MESSAGE:${JSON.stringify(error)}`
              );

            this.googleAnalyticsService.sendEvent(eventBuilder.getResult());
            this.error.navigateToErrorPage();
          });
        }
      },
      (error) => {
        //TODO Analytics => error while logging out
        eventBuilder
          .setAction('API ERROR')
          .setLabel(
            `PRODUCT_LOGOUT_URI:${
              this.auth.productLogoutURI
            }:ERROR_MESSAGE:${JSON.stringify(error)}`
          )
          .setBeacon();
        this.googleAnalyticsService.sendEvent(eventBuilder.getResult());
        this.error.navigateToErrorPage('', window.location.origin + "/authenticate");
      }
    );
  }
}
